<template>
  <div class="row mt-2 mb-3 mx-md-3">
    <div v-if="begin_process" class="col-md-7 mx-auto offset-lg-2 my-3">
      <div class="dashboard-card px-3 pt-3 pb-1 mb-3 h-100 rounded-0">
        <!-- FORM ONE -->
        <div v-if="current_form == 1">
          <form
            @submit.prevent="submitFirstForm"
            @keydown="formone.onKeydown($event)"
            class="mt-3 get-loan px-3"
          >
            <div>
              <h5 class="text-orange mb-0">Loan Information</h5>
              <p class="text-dark small mt-2">
                Provide the following information in order to continue the
                processing of loan application
              </p>

              <div class="form-row">
                <div class="form-group col-lg-4">
                  <label class="small text-dim font-italic">Firstname</label>
                  <input
                    type="text"
                    name="firstname"
                    class="form-control"
                    placeholder="First Name"
                    disabled
                    v-model="formone.firstname"
                    :class="{ 'is-invalid': formone.errors.has('firstname') }"
                  />
                  <has-error :form="formone" field="firstname" />
                </div>

                <div class="form-group col-lg-4">
                  <label class="small text-dim font-italic">Surname</label>
                  <input
                    type="text"
                    name="surname"
                    class="form-control"
                    placeholder="Surname"
                    disabled
                    v-model="formone.surname"
                    :class="{ 'is-invalid': formone.errors.has('surname') }"
                  />
                  <has-error :form="formone" field="surname" />
                </div>

                <div class="form-group col-lg-4">
                  <label class="small text-dim font-italic">Middle name</label>
                  <input
                    type="text"
                    name="middlename"
                    class="form-control"
                    placeholder="Middle Name"
                    disabled
                    v-model="formone.middlename"
                    :class="{ 'is-invalid': formone.errors.has('middlename') }"
                  />
                  <has-error :form="formone" field="middlename" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Email</label>

                  <input
                    type="email"
                    name="email"
                    class="form-control"
                    placeholder="Email Address"
                    disabled
                    v-model="formone.email"
                    :class="{ 'is-invalid': formone.errors.has('email') }"
                  />
                  <has-error :form="formone" field="email" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Phone number</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Mobile Number"
                    disabled
                    name="mobile_number"
                    v-model="formone.mobile_number"
                    :class="{
                      'is-invalid': formone.errors.has('mobile_number')
                    }"
                  />
                  <has-error :form="formone" field="mobile_number" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >This is your date of birth</label
                  >
                  <input
                    type="text"
                    disabled
                    class="form-control date"
                    name="dob"
                    v-model="formone.dob"
                    :class="{ 'is-invalid': formone.errors.has('dob') }"
                  />
                  <has-error :form="formone" field="dob" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">BVN</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    name="bvn"
                    v-model="formone.bvn"
                    :class="{ 'is-invalid': formone.errors.has('bvn') }"
                  />
                  <has-error :form="formone" field="bvn" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-4">
                  <label class="small text-dim font-italic">Nationality</label>

                  <input
                    @keyup="debounceNationality"
                    type="text"
                    class="form-control"
                    data-loader="nationality_loader"
                    name="nationality"
                    v-model="formone.nationality"
                    :class="{
                      'is-invalid': formone.errors.has('nationality')
                    }"
                  />
                  <div ref="nationality_loader" class="country-loader"></div>

                  <div class="countries_list" v-if="nationality_search">
                    <ul>
                      <li
                        v-for="residence in loan_parameters.countries"
                        :data-name="residence.name"
                        @click="selectNationlity($event)"
                        :key="residence.id"
                      >
                        {{ residence.name }}
                      </li>
                    </ul>
                  </div>

                  <has-error :form="formone" field="nationality" />
                </div>

                <div class="form-group col-lg-4">
                  <label class="small text-dim font-italic"
                    >State of origin</label
                  >
                  <select
                    @change="clearError"
                    class="custom-select"
                    name="state_of_origin"
                    v-model="formone.state_of_origin"
                    :class="{
                      'is-invalid': formone.errors.has('state_of_origin')
                    }"
                  >
                    <option value="">-- select --</option>
                    <option
                      v-for="state in loan_parameters.states"
                      :key="state.id"
                      :value="state.id"
                      >{{ state.title }}
                    </option>
                  </select>
                  <has-error :form="formone" field="state_of_origin" />
                </div>

                <div class="form-group col-lg-4">
                  <label class="small text-dim font-italic"
                    >LGA of origin</label
                  >
                  <select
                    @change="clearError"
                    class="custom-select"
                    name="LGA_of_origin"
                    v-model="formone.LGA_of_origin"
                    :class="{
                      'is-invalid': formone.errors.has('LGA_of_origin')
                    }"
                  >
                    <option value=""> -- select -- </option>
                    <option
                      v-for="lga in loan_parameters.origin_lga"
                      :key="lga.id"
                      :value="lga.id"
                      >{{ lga.title }}
                    </option>
                  </select>
                  <has-error :form="formone" field="LGA_of_origin" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Gender</label>
                  <select
                    @change="clearError"
                    class="custom-select"
                    name="gender"
                    v-model="formone.gender"
                    :class="{ 'is-invalid': formone.errors.has('gender') }"
                  >
                    <option value="">-- select --</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                  <has-error :form="formone" field="gender" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Marital status</label
                  >
                  <select
                    @change="clearError"
                    class="custom-select"
                    name="marital_status"
                    v-model="formone.marital_status"
                    :class="{
                      'is-invalid': formone.errors.has('marital_status')
                    }"
                  >
                    <option value="">-- select --</option>
                    <option
                      v-for="marital_status in loan_parameters.marital_status"
                      :key="marital_status.id"
                      :value="marital_status.id"
                      >{{ marital_status.title }}</option
                    >
                  </select>
                  <has-error :form="formone" field="marital_status" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-12">
                  <label class="small text-dim font-italic"
                    >Residential address</label
                  >
                  <textarea
                    placeholder=""
                    class="form-control"
                    rows="3"
                    name="residential_address"
                    v-model="formone.residential_address"
                    :class="{
                      'is-invalid': formone.errors.has('residential_address')
                    }"
                  ></textarea>
                  <has-error :form="formone" field="residential_address" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6 position-relative">
                  <label class="small text-dim font-italic"
                    >Country of residence</label
                  >

                  <input
                    @keyup="debounceCountryOfResidence"
                    type="text"
                    class="form-control"
                    data-loader="country_of_residence_loader"
                    name="country_of_residence"
                    v-model="formone.country_of_residence"
                    :class="{
                      'is-invalid': formone.errors.has('country_of_residence')
                    }"
                  />
                  <div
                    ref="country_of_residence_loader"
                    class="country-loader"
                  ></div>
                  <has-error :form="formone" field="country_of_residence" />

                  <div
                    class="countries_list"
                    v-if="country_of_residence_search"
                  >
                    <ul>
                      <li
                        v-for="residence in loan_parameters.countries"
                        :data-name="residence.name"
                        @click="selectResidenceCountry($event)"
                        :key="residence.id"
                      >
                        {{ residence.name }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >State of residence</label
                  >
                  <select
                    @change="clearError"
                    class="custom-select"
                    name="state_of_residence"
                    v-model="formone.state_of_residence"
                    :class="{
                      'is-invalid': formone.errors.has('state_of_residence')
                    }"
                  >
                    <option value="">-- select --</option>
                    <option
                      v-for="state in loan_parameters.states"
                      :key="state.id"
                      :value="state.id"
                      >{{ state.title }}
                    </option>
                  </select>
                  <has-error :form="formone" field="state_of_residence" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >LGA of residence</label
                  >
                  <select
                    @change="clearError"
                    class="custom-select"
                    name="LGA_of_residence"
                    v-model="formone.LGA_of_residence"
                    :class="{
                      'is-invalid': formone.errors.has('LGA_of_residence')
                    }"
                  >
                    <option value=""> -- select -- </option>
                    <option
                      v-for="residence_lga in loan_parameters.residence_lga"
                      :key="residence_lga.id"
                      :value="residence_lga.id"
                      >{{ residence_lga.title }}</option
                    >
                  </select>
                  <has-error :form="formone" field="LGA_of_residence" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Number of dependents</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="E.g 0"
                    name="number_of_dependents"
                    v-model="formone.number_of_dependents"
                    :class="{
                      'is-invalid': formone.errors.has('number_of_dependents')
                    }"
                  />
                  <has-error :form="formone" field="number_of_dependents" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Tax ID</label>

                  <input
                    type="text"
                    class="form-control"
                    placeholder=""
                    name="tax_ID"
                    v-model="formone.tax_ID"
                    :class="{
                      'is-invalid': formone.errors.has('tax_ID')
                    }"
                  />
                  <has-error :form="formone" field="tax_ID" />
                </div>
              </div>

              <div class="d-flex mt-4">
                <div class="col px-lg-0"></div>
                <div class="col text-right px-lg-0">
                  <button type="submit" class="btn btn-next px-5 next">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- FORM TWO -->
        <div v-if="current_form == 2">
          <form
            @submit.prevent="submitSecondForm"
            @keydown="formtwo.onKeydown($event)"
            class="mt-3 get-loan px-3"
          >
            <div>
              <h5 class="text-orange mb-0">Employment Information</h5>
              <p class="text-dark small">
                Provide the following information in order to continue the
                processing of loan application
              </p>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Company Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="company_name"
                    v-model="formtwo.company_name"
                    :class="{
                      'is-invalid': formtwo.errors.has('company_name')
                    }"
                  />
                  <has-error :form="formtwo" field="company_name" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Occupation</label>
                  <input
                    type="text"
                    class="form-control"
                    name="occupation"
                    v-model="formtwo.occupation"
                    :class="{
                      'is-invalid': formtwo.errors.has('occupation')
                    }"
                  />
                  <has-error :form="formtwo" field="occupation" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-12">
                  <label class="small text-dim font-italic"
                    >Office/Work Address</label
                  >
                  <textarea
                    type="text"
                    class="form-control"
                    name="work_address"
                    v-model="formtwo.work_address"
                    :class="{
                      'is-invalid': formtwo.errors.has('work_address')
                    }"
                  ></textarea>
                  <has-error :form="formtwo" field="work_address" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Work Sector</label>
                  <select
                    @change="clearError"
                    class="custom-select"
                    name="work_sector"
                    v-model="formtwo.work_sector"
                    :class="{
                      'is-invalid': formtwo.errors.has('work_sector')
                    }"
                  >
                    <option value="">-- Select --</option>
                    <option
                      v-for="work_sector in loan_parameters.work_sector"
                      :key="work_sector.id"
                      :value="work_sector.id"
                      >{{ work_sector.title }}</option
                    >
                  </select>
                  <has-error :form="formtwo" field="work_sector" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Employment Status</label
                  >
                  <select
                    @change="clearError"
                    name="employee_status"
                    class="custom-select"
                    v-model="formtwo.employee_status"
                    :class="{
                      'is-invalid': formtwo.errors.has('employee_status')
                    }"
                  >
                    <option value="">-- select --</option>
                    <option
                      v-for="employee_status in loan_parameters.employee_status"
                      :key="employee_status.id"
                      :value="employee_status.id"
                      >{{ employee_status.title }}</option
                    >
                  </select>
                  <has-error :form="formtwo" field="work_sector" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Years in current employment</label
                  >
                  <select
                    @change="clearError"
                    name="years_in_employment"
                    class="custom-select"
                    v-model="formtwo.years_in_employment"
                    :class="{
                      'is-invalid': formtwo.errors.has('years_in_employment')
                    }"
                  >
                    <option value="">-- select --</option>
                    <option v-for="n in 50" :key="n" :value="n">{{ n }}</option>
                  </select>
                  <has-error :form="formtwo" field="work_sector" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Official email</label
                  >
                  <input
                    type="email"
                    class="form-control"
                    name="official_email"
                    v-model="formtwo.official_email"
                    :class="{
                      'is-invalid': formtwo.errors.has('official_email')
                    }"
                  />
                  <has-error :form="formtwo" field="official_email" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Annual Income</label
                  >
                  <currency-input
                    name="annual_income"
                    v-model="formtwo.annual_income"
                    class="form-control"
                    :class="{
                      'is-invalid': formtwo.errors.has('annual_income')
                    }"
                  />
                  <!-- <input
                    type="text"
                    class="form-control"
                    name="annual_income"
                    v-model="formtwo.annual_income"
                    :class="{
                      'is-invalid': formtwo.errors.has('annual_income')
                    }"
                  /> -->
                  <has-error :form="formtwo" field="annual_income" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Monthly Net Salary</label
                  >
                  <currency-input
                    name="monthly_net_salary"
                    v-model="formtwo.monthly_net_salary"
                    class="form-control"
                    :class="{
                      'is-invalid': formtwo.errors.has('monthly_net_salary')
                    }"
                  />

                  <has-error :form="formtwo" field="monthly_net_salary" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Salary date</label>

                  <datepicker
                    :input-class="{
                      'is-invalid': formtwo.errors.has('salary_date'),
                      'form-control': true
                    }"
                    v-model="formtwo.salary_date"
                    :name="salary_date"
                    :minimumView="'day'"
                    :maximumView="'day'"
                    :format="customDateFormat"
                  ></datepicker>
                  <has-error :form="formtwo" field="salary_date" />
                </div>
              </div>

              <h5 class="text-orange mb-0">Emergency Contact Information</h5>
              <p class="text-dark small mt-2">
                Provide the details of your next of kin
              </p>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">First Name</label>
                  <input
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    name="emergency_firstname"
                    v-model="formtwo.emergency_firstname"
                    :class="{
                      'is-invalid': formtwo.errors.has('emergency_firstname')
                    }"
                  />
                  <has-error :form="formtwo" field="emergency_firstname" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Surname</label>
                  <input
                    type="text"
                    class="form-control"
                    autocomplete="off"
                    name="emergency_surname"
                    v-model="formtwo.emergency_surname"
                    :class="{
                      'is-invalid': formtwo.errors.has('emergency_surname')
                    }"
                  />
                  <has-error :form="formtwo" field="emergency_surname" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">Phone Number</label>
                  <input
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    name="emergency_phone_number"
                    v-model="formtwo.emergency_phone_number"
                    :class="{
                      'is-invalid': formtwo.errors.has('emergency_phone_number')
                    }"
                  />
                  <has-error :form="formtwo" field="emergency_phone_number" />
                </div>

                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic"
                    >Email Address</label
                  >
                  <input
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    name="emergency_email"
                    v-model="formtwo.emergency_email"
                    :class="{
                      'is-invalid': formtwo.errors.has('emergency_email')
                    }"
                  />
                  <has-error :form="formtwo" field="emergency_email" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-6">
                  <label class="small text-dim font-italic">
                    Relationship</label
                  >

                  <select
                    class="custom-select"
                    name="emergency_relationship"
                    v-model="formtwo.emergency_relationship"
                    :class="{
                      'is-invalid': formtwo.errors.has('emergency_relationship')
                    }"
                  >
                    <option value="">-- select --</option>
                    <option value="brother">Brother</option>
                    <option value="sister">Sister</option>
                    <option value="husband">Husband</option>
                    <option value="wife">Wife</option>
                    <option value="father">Father</option>
                    <option value="mother">Mother</option>
                    <option value="son">Son</option>
                    <option value="daughter">Daughter</option>
                    <option value="others">Others</option>
                  </select>

                  <has-error :form="formtwo" field="emergency_relationship" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-12">
                  <label class="small text-dim font-italic"> Address</label>
                  <textarea
                    type="email"
                    autocomplete="off"
                    class="form-control"
                    name="emergency_address"
                    v-model="formtwo.emergency_address"
                    :class="{
                      'is-invalid': formtwo.errors.has('emergency_address')
                    }"
                  ></textarea>
                  <has-error :form="formtwo" field="emergency_address" />
                </div>
              </div>

              <h5 class="text-orange mb-4">
                Existing loan facility with other lenders
              </h5>

              <div class="append_line">
                <LoanFacility
                  v-for="(facility, index) in loan_facility"
                  :facility="facility"
                  :key="facility.id"
                  :index="index"
                  @removeExistingLoanFacility="removeExistingLoanFacility"
                />
              </div>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <p class="text-grey mb-0 mt-2">
                    <a
                      class="small"
                      href="javascript:void(0)"
                      @click="addExistingLoanFacility"
                      >+ Click Add Outstanding Loans</a
                    >
                  </p>
                </div>
              </div>

              <div class="custom-control custom-checkbox mt-4">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="deduct_upfront_fee_1"
                  name="deduct_upfront_fee"
                  v-model="formtwo.deduct_upfront_fee"
                  :class="{
                    'is-invalid': formtwo.errors.has('deduct_upfront_fee')
                  }"
                />
                <label
                  class="custom-control-label font-weight-light check_label"
                  for="deduct_upfront_fee_1"
                  >Deduct upfront fee for loan facility</label
                >
              </div>

              <div class="d-flex my-4">
                <div class="col px-lg-0">
                  <button
                    @click="back"
                    type="button"
                    class="btn btn-back px-5 previous"
                  >
                    Back
                  </button>
                </div>
                <div class="col text-right px-lg-0">
                  <button type="submit" class="btn btn-next px-5 next">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- FORM THREE -->
        <div v-if="current_form == 3">
          <form
            @submit.prevent="submitThirdForm"
            @keydown="formthree.onKeydown($event)"
            class="mt-3 get-loan px-3"
          >
            <div>
              <div>
                <h5 class="text-orange">Means Of Identification</h5>
                <p class="text-dark small">Upload Your Passport Photograph</p>

                <div class="form-group row align-center">
                  <div
                    for="company_profile"
                    class="col-sm-3 col-form-label  text-center"
                  >
                    <div class="border rounded px-2">
                      <img src="@/assets/img/xls.svg" class="img-fluid py-3" />
                    </div>
                  </div>

                  <div class="col-sm-6 col-8">
                    <input
                      type="text"
                      v-model="formthree.passport_upload"
                      class="form-control file_height file_name"
                      disabled
                      placeholder="Upload Document.."
                      :class="{
                        'is-invalid': formthree.errors.has('passport_upload')
                      }"
                    />
                    <has-error :form="formthree" field="passport_upload" />
                  </div>
                  <div class="col-sm-3 col-4 upload-btn-wrapper">
                    <button type="button" class="btn btn-upload btn-block">
                      Browse File
                    </button>
                    <input
                      accept="image/*,application/pdf"
                      @change="onFileChange"
                      ref="passport_upload"
                      data-target="passport_upload"
                      type="file"
                      name="passport_upload"
                    />
                  </div>
                </div>

                <p class="text-dark small mb-0">
                  Upload Any Valid Means Of Identification
                </p>
                <p class="text-orange small">
                  (Drivers License, International Passport, National ID Card,
                  Voters card, and NIMC ID)
                </p>

                <div class="form-row">
                  <div class="form-group col-lg-6">
                    <label class="small text-dim font-italic">ID Number</label>
                    <input
                      type="text"
                      class="form-control"
                      name="ID_number"
                      v-model="formthree.ID_number"
                      :class="{
                        'is-invalid': formthree.errors.has('ID_number')
                      }"
                    />
                    <has-error :form="formthree" field="ID_number" />
                  </div>

                  <div class="form-group col-lg-6">
                    <label class="small text-dim font-italic"
                      >Expiry Date</label
                    >

                    <datepicker
                      :input-class="{
                        'is-invalid': formthree.errors.has('ID_expiry_date'),
                        'form-control': true
                      }"
                      v-model="formthree.ID_expiry_date"
                      name="ID_expiry_date"
                      :minimumView="'month'"
                      :maximumView="'year'"
                      :format="customExpiryDateFormat"
                    ></datepicker>
                    <has-error :form="formthree" field="ID_expiry_date" />
                  </div>
                </div>

                <div class="form-group row align-center">
                  <div
                    for="company_profile"
                    class="col-sm-3 col-form-label  text-center"
                  >
                    <div class="border rounded px-2">
                      <img src="@/assets/img/xls.svg" class="img-fluid py-3" />
                    </div>
                  </div>
                  <div class="col-sm-6 col-8">
                    <input
                      type="text"
                      v-model="formthree.ID_upload"
                      class="form-control file_height file_name"
                      disabled
                      placeholder="Upload Document.."
                      :class="{
                        'is-invalid': formthree.errors.has('ID_upload')
                      }"
                    />
                    <has-error :form="formthree" field="ID_upload" />
                  </div>
                  <div class="col-sm-3 col-4 upload-btn-wrapper">
                    <button type="button" class="btn btn-upload btn-block">
                      Browse File
                    </button>
                    <input
                      accept="image/*,application/pdf"
                      @change="onFileChange"
                      ref="ID_upload"
                      data-target="ID_upload"
                      type="file"
                      name="ID_upload"
                    />
                  </div>
                </div>

                <p class="text-dark small mb-0">
                  Upload Utility Bill or Any Valid Means Of Address
                  Identification
                </p>
                <p class="text-orange small">
                  (The Means Of ID Should Be Different From The Above And Have
                  Address Stated)
                </p>

                <div class="form-group row align-center">
                  <div
                    for="company_profile"
                    class="col-sm-3 col-form-label  text-center"
                  >
                    <div class="border rounded px-2">
                      <img src="@/assets/img/xls.svg" class="img-fluid py-3" />
                    </div>
                  </div>
                  <div class="col-sm-6 col-8">
                    <input
                      type="text"
                      v-model="formthree.utility_upload"
                      class="form-control file_height file_name"
                      disabled
                      placeholder="Upload Document.."
                      :class="{
                        'is-invalid': formthree.errors.has('utility_upload')
                      }"
                    />
                    <has-error :form="formthree" field="utility_upload" />
                  </div>
                  <div class="col-sm-3 col-4 upload-btn-wrapper">
                    <button type="button" class="btn btn-upload btn-block">
                      Browse File
                    </button>
                    <input
                      accept="image/*,application/pdf"
                      @change="onFileChange"
                      data-target="utility_upload"
                      ref="utility_upload"
                      type="file"
                      name="utility_upload"
                    />
                  </div>
                </div>

                <p class="text-dark small mb-0">
                  Employment Letter
                </p>
                <p class="text-orange small">
                  (Employment Letter / Confirmation Letter / Promotion Letter /
                  Salary Review)
                </p>

                <div class="form-group row align-center">
                  <div
                    for="company_profile"
                    class="col-sm-3 col-form-label  text-center"
                  >
                    <div class="border rounded px-2">
                      <img src="@/assets/img/xls.svg" class="img-fluid py-3" />
                    </div>
                  </div>
                  <div class="col-sm-6 col-8">
                    <input
                      type="text"
                      v-model="formthree.employment_upload"
                      class="form-control file_height file_name"
                      placeholder="Upload Document.."
                      disabled
                      :class="{
                        'is-invalid': formthree.errors.has('employment_upload')
                      }"
                    />
                    <has-error :form="formthree" field="employment_upload" />
                  </div>
                  <div class="col-sm-3 col-4 upload-btn-wrapper">
                    <button type="button" class="btn btn-upload btn-block">
                      Browse File
                    </button>
                    <input
                      accept="image/*,application/pdf"
                      @change="onFileChange"
                      ref="employment_upload"
                      data-target="employment_upload"
                      type="file"
                      name="employment_upload"
                    />
                  </div>
                </div>

                <div v-if="document_uploading_progress > 0" class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    v-bind:style="{
                      backgroundColor: '#FD6C1D',
                      width: document_uploading_progress + '%'
                    }"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                <div class="d-flex my-4">
                  <div class="col px-lg-0">
                    <button
                      @click="back"
                      type="button"
                      class="btn btn-back px-5 previous"
                    >
                      Back
                    </button>
                  </div>
                  <div class="col text-right px-lg-0">
                    <button type="submit" class="btn btn-next px-5 next">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- FORM FOUR -->
        <div v-if="current_form == 4">
          <form
            @submit.prevent="submitFourthForm"
            @keydown="formfour.onkeydown($event)"
            class="mt-3 get-loan px-3"
          >
            <div>
              <h5 class="text-orange mb-4">Loan Information</h5>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic">Loan Amount</label>
                  <currency-input
                    name="loan_amount"
                    v-model="formfour.loan_amount"
                    class="form-control"
                    :class="{
                      'is-invalid': formfour.errors.has('loan_amount')
                    }"
                  />
                  <has-error :form="formfour" field="loan_amount" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic">Loan Tenure</label>
                  <select
                    @change="clearError"
                    name="loan_tenure"
                    class="custom-select"
                    v-model="formfour.loan_tenure"
                    :class="{
                      'is-invalid': formfour.errors.has('loan_tenure')
                    }"
                  >
                    <option value=""> -- select --</option>
                    <option
                      v-for="tenure in loan_parameters.employee_loan_tenure"
                      :key="tenure.id"
                      :value="tenure.title"
                      >{{ tenure.title + " months" }}</option
                    >
                  </select>
                  <has-error :form="formfour" field="loan_tenure" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic"
                    >Loan Amount Payable Monthly To Other Institutions</label
                  >
                  <currency-input
                    v-model="formfour.other_institutions_loan"
                    class="form-control"
                    :class="{
                      'is-invalid': formfour.errors.has(
                        'other_institutions_loan'
                      )
                    }"
                  />
                  <has-error :form="formfour" field="other_institutions_loan" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic"
                    >Purpose Of Loan Acquisition</label
                  >
                  <select
                    type="text"
                    v-model="formfour.loan_purpose"
                    class="custom-select"
                    name="loan_purpose"
                    :class="{
                      'is-invalid': formfour.errors.has('loan_purpose')
                    }"
                  >
                    <option value=""> -- select -- </option>
                    <option
                      v-for="purpose in loan_parameters.employee_loan_purpose"
                      :key="purpose.id"
                      :value="purpose.id"
                      >{{ purpose.title }}</option
                    >
                  </select>
                  <has-error :form="formfour" field="loan_purpose" />
                </div>
              </div>

              <div class="d-flex my-4">
                <div class="col px-lg-0">
                  <button
                    type="button"
                    @click="back"
                    class="btn btn-back px-5 previous"
                  >
                    Back
                  </button>
                </div>
                <div class="col text-right px-lg-0">
                  <button type="submit" class="btn btn-next px-5 next">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- FORM FIVE -->
        <div v-if="current_form == 5">
          <form @submit.prevent="submitFifthForm" class="mt-3 get-loan px-3">
            <div>
              <h5 class="text-orange mb-4">Loan Information</h5>

              <p class="text-dark font-15">
                Amount Interest:
                <span class="weight-600">{{
                  loan_results.amount_interest + "%"
                }}</span>
              </p>
              <p class="text-dark font-15">
                Monthly Repayment:
                <span class="weight-600"
                  >NGN {{ loan_results.monthly_repayment | money }} /
                  Month</span
                >
              </p>
              <!-- <p class="text-dark font-15">
                Total Amount Payable:
                <span class="weight-600"
                  >NGN {{ loan_results.amount_payable | money }}</span
                >
              </p> -->
              <p class="text-dark mb-0 font-15">
                Submit Salary Account Details
              </p>
              <p class="text-orange font-15">
                (Account Must Be Tied To BVN Submitted)
              </p>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic">Bank Name</label>
                  <select
                    id="bank_name"
                    @change="bankNameChanged"
                    class="custom-select"
                    name="bank_name"
                    v-model="formfive.bank_name"
                    :class="{
                      'is-invalid': formfive.errors.has('bank_name')
                    }"
                  >
                    <option value=""> -- select bank name --</option>
                    <option
                      data-bank_code="bank.code"
                      v-for="bank in loan_parameters.banks"
                      :key="bank.id"
                      :value="bank.id"
                      >{{ bank.name }}</option
                    >
                  </select>
                  <has-error :form="formfive" field="bank_name" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic"
                    >Account Number</label
                  >
                  <input
                    @change="clearError"
                    type="text"
                    class="form-control"
                    name="account_number"
                    maxlength="10"
                    v-model="formfive.account_number"
                    :class="{
                      'is-invalid': formfive.errors.has('account_number')
                    }"
                  />
                  <has-error :form="formfive" field="account_number" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic">Account Name</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    name="account_name"
                    v-model="formfive.account_name"
                    :class="{
                      'is-invalid': formfive.errors.has('account_name')
                    }"
                  />
                  <has-error :form="formfive" field="account_name" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-lg-7">
                  <label class="small text-dim font-italic"
                    >Phone number linked to bank details above</label
                  >
                  <input
                    @change="clearError"
                    type="text"
                    class="form-control"
                    name="bank_phone"
                    maxlength="14"
                    v-model="formfive.bank_phone"
                    :class="{
                      'is-invalid': formfive.errors.has('bank_phone')
                    }"
                  />
                  <has-error :form="formfive" field="bank_phone" />
                </div>
              </div>

              <!-- <p class="font-13 text-dark text-center">
                <span class="font-weight-bold text-orange">NOTE</span> : You
                will not be able to modify loan information from this point.
              </p> -->

              <div class="d-flex my-4">
                <div class="col px-lg-0">
                  <button
                    @click="back"
                    type="button"
                    class="btn btn-back px-5 previous"
                  >
                    Back
                  </button>
                </div>
                <div class="col text-right px-lg-0">
                  <button type="submit" class="btn btn-next px-5 next">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- FORM SIX -->
        <div v-if="current_form == 6">
          <form class="mt-3 get-loan px-3">
            <div>
              <h5 class="text-orange mb-4 text-center">
                Bank Statement Retrieval
              </h5>

              <p class="font-13 text-dark">
                <span class="font-weight-bold">NOTE</span> : To complete your
                Loan appliction request, we would need 6 months statement of
                your salary account. It costs
                <span class="text-orange font-21">₦400</span> to electronically
                retrieve your bank statement. Please note that this amount
                doesn't come from ORANGE ONE and is charged directly from your
                account after you get an approval ticket number.
              </p>

              <div class="row">
                <div class="col-md-12 mt-4 ">
                  <div class="d-flex justify-content-center">
                    <div
                      class="text-center w-50 bank"
                      @click="triggerManualRetrievalModal"
                    >
                      <img
                        src="@/assets/img/bank.svg"
                        class="img-fluid py-1"
                        style="width:35px;"
                      />
                      <p class="font-13 font-weight-bold text-dark">
                        Manual Retrieval
                      </p>
                    </div>
                    <div
                      class="text-center w-50 bank"
                      @click="triggerAutoRetrievalModal"
                    >
                      <img
                        src="@/assets/img/monitor.svg"
                        class="img-fluid py-1"
                        style="width:35px;"
                      />
                      <p class="font-13 font-weight-bold text-dark">
                        Automatic&nbsp;Retrieval
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 my-4 text-left">
                  &laquo;
                  <span
                    style="cursor:pointer; text-decoration:underline;"
                    @click="back"
                  >
                    Back</span
                  >
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- FORM SEVEN -->
        <div v-if="current_form == 7">
          <div class="mt-3 get-loan px-3">
            <div>
              <h5 class="text-orange mb-4 text-center">
                Bank Statement Payment
              </h5>

              <p class="font-13 text-dark">
                A ticket number and Password will be sent to you via email/SMS
                within 24 hours. Enter the ticket number and password in the
                fields below after you have made payment of
                <span class="text-orange font-21">₦400</span>
                <br />

                <small class="text-orange"
                  >Your progress is saved, you can continue from this point at a
                  latter time</small
                >
              </p>

              <div class="w-100 text-center mb-4">
                <button
                  v-if="!statement_payment"
                  class="btn btn-next pay"
                  type="button"
                  @click="payStatementFee"
                >
                  Pay ₦400
                </button>

                <button
                  v-else
                  class="btn btn-next pay"
                  style="background-color:#25D96D"
                  type="button"
                >
                  ₦400 payment successful
                </button>
              </div>

              <hr />

              <div :class="{ no_action: !statement_payment }">
                <h5 class="text-orange mb-4 mt-3 text-center">
                  Bank Statement Confirmation
                </h5>

                <form
                  @submit.prevent="submitSeventhForm"
                  @keydown="formseven.onKeydown($event)"
                  class="mt-3 get-loan px-3 w-100 mb-5"
                >
                  <div class="row">
                    <div class="col-md-10 col-sm-12 mx-auto">
                      <div class="form-group">
                        <label class="small text-dim font-italic"
                          >Ticket Number</label
                        >
                        <input
                          @change="clearError"
                          :disabled="!statement_payment"
                          placeholder="E.g 1021122-32"
                          type="text"
                          class="form-control w-100"
                          name="ticket_number"
                          v-model="formseven.ticket_number"
                          :class="{
                            'is-invalid': formseven.errors.has('ticket_number')
                          }"
                        />
                        <has-error :form="formseven" field="ticket_number" />
                      </div>

                      <div class="form-group">
                        <label class="small text-dim font-italic"
                          >Password</label
                        >
                        <input
                          @change="clearError"
                          :disabled="!statement_payment"
                          type="text"
                          class="form-control"
                          name="password"
                          v-model="formseven.password"
                          :class="{
                            'is-invalid': formseven.errors.has('password')
                          }"
                        />
                        <has-error :form="formseven" field="password" />
                      </div>

                      <div class="w-100 text-center">
                        <button
                          :disabled="!statement_payment"
                          type="submit"
                          class="btn btn-next px-5 next w-100"
                        >
                          Complete&nbsp;Application
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- FORM  PROCESSING -->
        <div v-if="current_form == 8">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row justify-content-center">
                <div
                  class="col-lg-10 text-center"
                  style="padding-bottom: 40px;"
                >
                  <img src="@/assets/img/processed_mail.svg" />
                  <p class=" text-orange text-center my-4">
                    Loan application completed.
                  </p>
                  <p class="font-13 text-center my-4">
                    You have successfully completed the loan process, we will
                    review your bank statement and determine if you are eligible
                    for this
                    <span class="text-orange">
                      <router-link
                        :to="{
                          path: `/history/${loan.processing_loan_information.id}`
                        }"
                        >loan</router-link
                      > </span
                    >. You will be notified of the outcome via an email.
                  </p>

                  <div class="d-flex">
                    <button
                      class="btn orange_button px-5 mx-auto my-4"
                      @click.prevent="triggerCancelModal"
                    >
                      Cancel&nbsp;Application
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--MANUAL STATEMENT  AWAITING -->
        <div v-if="current_form == 9">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row justify-content-center">
                <div class="col-lg-10 text-center">
                  <h5 class="text-orange text-center mt-4">
                    Loan Application Partially Completed
                  </h5>
                  <img src="@/assets/img/processed_mail.svg" />
                  <p class="font-13 text-orange text-center my-4">
                    We are waiting to recieve your bank statement from your
                    bank. You will be notified via an email when we receive it.
                  </p>
                  <div class="text">
                    <p>Email: {{ this.loan.bank_statement_email }}</p>
                    <p v-if="loan.processing_loan_information">
                      Statement ID:
                      {{ loan.processing_loan_information.statement_token }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- FORM TEN (Active loan) -->
        <div v-if="current_form == 10">
          <div class="card px-3 pt-3 pb-1 mb-3 mt-2 h-100 border-0">
            <p class="text-dark text-center small mb-0 mt-3">
              You have an active loan process, only one active loan is allowed.
              To get more money use the <span class="tex">top up</span> feature
              which enables you to get more money even when u have a running
              loan. If you have an active loan you can top up by clicking the
              button below.
            </p>

            <div class="d-flex">
              <button
                class="btn orange_button px-5 mx-auto my-4 col-lg-6"
                data-toggle="modal"
                data-target="#otp_modal"
              >
                Top Up
              </button>
            </div>
          </div>
        </div>
        <!-- Acccept offer  -->
        <div v-if="current_form == 14">
          <div class="card px-3 pt-3 pb-1 mb-3 h-100 border-0">
            <h5 class="text-dark text-center">
              Dear
              <span class="text-orange">
                <router-link to="/profile">
                  {{ user.firstname }} {{ user.surname }}
                </router-link>
              </span>
            </h5>

            <p class="text-dark text-center small mb-0 mt-1">
              Your loan has been temporarily approved. To proceed, you need to

              <span class="text-orange">
                <span class="text-orange bank">
                  <a :href="offer_url" @click="offer_downloaded = true"
                    ><strong>download the loan offer here.</strong>
                  </a>
                </span>
              </span>
              To accept the offer, attach your signature to the downloaded offer
              letter and re-upload.
            </p>

            <p class="text-dark text-center small mb-0 mt-1">
              If this offer is not acceptable or you wish to decline the offer,
              click on this link
              <span class="text-orange"
                ><a @click.prevent="triggerCancelModal" href="#"
                  >Reject Offer</a
                ></span
              >
            </p>

            <div v-if="offer_downloaded">
              <div class="form-group mt-3">
                <label class="small" for="reuploadOffer"
                  >Upload offer letter</label
                >
                <input
                  accept="image/*,application/pdf"
                  required
                  type="file"
                  class="form-control-file small text-dim"
                  id="reuploadOffer"
                  ref="reuploadOffer"
                />
              </div>

              <div v-if="offer_uploading_progress > 0" class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  v-bind:style="{
                    backgroundColor: '#FD6C1D',
                    width: offer_uploading_progress + '%'
                  }"
                  aria-valuenow="0"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>

            <div class="d-flex">
              <button
                :disabled="!offer_downloaded"
                @click="uploadOffer"
                class="btn orange_button px-2 mx-auto my-4 col-lg-6"
              >
                Next
              </button>
            </div>
          </div>
        </div>

        <!-- Start Mandate setup -->
        <div v-if="current_form == 11">
          <div class="card px-3 pt-3 pb-1 mb-3 h-100 border-0">
            <h5 class="text-dark text-center">
              <span class="text-orange">
                Remitta Mandate Setup
              </span>
            </h5>
            <p class="text-dark text-center small mb-0 mt-1">
              Almost there! The next step before funds disbursment is subject to
              your creating + direct debit Mandate on your account This would
              automate the process of loan repayment from your salary account.
            </p>

            <div class="d-flex">
              <button
                class="btn orange_button px-5 mx-auto my-4 col-lg-6"
                data-toggle="modal"
                data-target="#otp_modal"
                @click="setupMandate"
              >
                Setup Mandate
              </button>
            </div>

            <div class="col-md-12 mt-2 small text-right">
              <span
                style="cursor:pointer; text-decoration:underline;"
                @click="chequeInstruction"
                >use cheque instead</span
              >
            </div>
          </div>
        </div>

        <!-- Mandate Activation method  -->
        <div v-if="current_form == 15">
          <form class="mt-3 get-loan px-3">
            <div>
              <h5 class="text-orange mb-4 text-center">
                Remitta Mandate Activation
              </h5>

              <p class="font-13 text-dark">
                You have successfully setup a Remitta Direct Debit Mandate on
                your account but it needs to be activated. <br />
                You may activate the mandate using the manual method or the
                portal method listed below.
              </p>

              <div class="row">
                <div class="col-md-12 mt-4 ">
                  <div class="d-flex justify-content-center">
                    <div
                      class="text-center w-50 bank"
                      @click="triggerManualRemittaModal"
                    >
                      <img
                        src="@/assets/img/bank.svg"
                        class="img-fluid py-1"
                        style="width:35px;"
                      />
                      <p class="font-13 font-weight-bold text-dark">
                        Manual Activation
                      </p>
                    </div>
                    <div
                      class="text-center w-50 bank"
                      @click="triggerAutoRemittaModal"
                    >
                      <img
                        src="@/assets/img/monitor.svg"
                        class="img-fluid py-1"
                        style="width:35px;"
                      />
                      <p class="font-13 font-weight-bold text-dark">
                        Portal&nbsp;Activation&nbsp;
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- verify Mandate  -->
        <div v-if="current_form == 12">
          <form
            @submit.prevent="verifyRemittaMandate"
            @keydown="remittaverification.onKeydown($event)"
            class="mt-3 get-loan px-3"
          >
            <div style="padding-bottom: 50px;">
              <h5 class="text-orange text-center mb-4">
                Direct Debit Mandate Activation
              </h5>

              <p class="font-13 text-dark">
                Your direct debit mandate has been setup successfully, but you
                need to
                <span class="text-orange">Activate</span> the mandate which will
                enable us charge your account monthly. This action is mandatory
                before the loan will be disbursed to your acccount
                {{ this.loan.processing_loan_information.account_number }}.
                <br />
              </p>
              <!-- <p class="font-13 text-dark"><br /></p> -->

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label class="small text-dim font-italic"
                    >Remitta Retrieval Reference (RRR)</label
                  >
                  <input
                    type="text"
                    name="rrr"
                    class="form-control"
                    disabled
                    v-model="remittaverification.rrr"
                    :class="{
                      'is-invalid': remittaverification.errors.has('rrr')
                    }"
                  />
                  <has-error :form="remittaverification" field="rrr" />
                </div>

                <div class="form-group col-md-12">
                  <label class="small text-dim font-italic"
                    >One Time Password (OTP)</label
                  >
                  <input
                    type="text"
                    name="otp"
                    class="form-control"
                    v-model="remittaverification.otp"
                    :class="{
                      'is-invalid': remittaverification.errors.has('otp')
                    }"
                  />
                  <has-error :form="remittaverification" field="otp" />
                </div>

                <div class="form-group col-md-12">
                  <label class="small text-dim font-italic"
                    >ATM Card Number</label
                  >
                  <input
                    type="text"
                    name="c_n"
                    class="form-control"
                    autocomplete="off"
                    v-model="remittaverification.c_n"
                    :class="{
                      'is-invalid': remittaverification.errors.has('c_n')
                    }"
                  />
                  <has-error :form="remittaverification" field="c_n" />
                </div>

                <div class="d-flex justify-content-center w-100">
                  <button class="btn orange_button px-5 mx-auto my-4 ">
                    Activate Mandate
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- manual mandate awaiting progresss  -->
        <div v-if="current_form == 16">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row justify-content-center">
                <div class="col-lg-10 text-center">
                  <img src="@/assets/img/success.svg" />
                  <p class="font-13 text-orange text-center my-4">
                    We are checking and will notify you via email when your
                    mandate is activated.
                  </p>
                  <br />
                  <div class="text">
                    <router-link
                      class="btn btn-orange px-4 mt-lg-3 wiggle"
                      to="/"
                    >
                      Home
                    </router-link>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="current_form == 13">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row justify-content-center">
                <div class="col-lg-10 text-center">
                  <img src="@/assets/img/success.svg" />
                  <p class="font-13 text-orange text-center my-4">
                    You have a loan awaiting disbursment
                  </p>
                  <br />
                  <div class="text">
                    <router-link
                      class="btn btn-orange px-4 mt-lg-3 wiggle"
                      to="/"
                    >
                      Home
                    </router-link>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <b-modal
      ref="processing-modal"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row justify-content-center">
              <div class="col-lg-10 text-center">
                <img src="@/assets/img/processed_mail.svg" />
                <p class="font-13 text-orange text-center my-4">
                  Your Loan Is Being Processed
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Automatic Modal -->
    <!-- others -->
    <b-modal
      ref="automatic_retrieval_init"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <form>
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <p class="font-13 text-dark text-center">
                    <span class="text-orange">GTB</span>,
                    <span class="text-orange">Zenith Bank </span>,
                    <span class="text-orange">City Bank </span> and
                    <span class="text-orange">Standard Chartered </span>
                    users please
                    <a
                      class="text-blue-underline"
                      href="#"
                      @click="differentStatementProcess"
                      >click here</a
                    >
                  </p>
                  <hr />
                  <p class="font-13 text-dark text-center my-4">
                    For banks not mentioned above click on the button below to
                    start the process of retrieving your
                    <span class="text-orange">6 months</span> bank statement.
                  </p>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <button
                    type="button"
                    class="btn orange_button btn-block mt-1"
                    @click="initAutomaticStatementRetrieval"
                  >
                    Start statement retrieval
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Different statement process modal  -->
    <b-modal
      ref="different_statement_process"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4 pt-0">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <form>
              <div class="row justify-content-center">
                <div class="col-lg-12">
                  <p class="font-13 text-dark text-center">
                    <span class="text-orange">Guaranty Trust</span>,
                    <span class="text-orange">Zenith Bank </span>,
                    <span class="text-orange">CityBank</span> and
                    <span class="text-orange">Standard Chartered </span>
                  </p>
                  <hr />
                  <p class="font-13 text-dark text-center my-4">
                    Kindly, visit your bank to instruct them accordingly.
                    Request that they send your 6 month bank statement to
                    <span class="text-orange"
                      >bankstatement@orangeonefinance.com</span
                    >
                    Your statement ID should be included in the email
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- custom -->
    <b-modal
      ref="custom_retrieval_init"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <h5 class="text-orange text-center">Retrieve GT Bank Statement</h5>
          <div class="col-lg-12" style="height: 180px;">
            <p class="font-13 text-dark text-center my-4">
              To complete the process, kindly login into your Mobile and
              Internet banking app to start the request on the "Request Bank
              Statement" on the platform. You would need them to process at a
              point in the application process. Please note that your card would
              be charged ₦400 for this service. Otherwise, you can use the
              manual process.
            </p>
          </div>

          <button
            type="button"
            class="btn orange_button btn-block mt-1"
            @click="toPaymentpage"
          >
            Proceed
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Manual Modal -->
    <b-modal
      ref="manual_retrieval"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <form>
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <p class="font-13 text-dark text-center my-4">
                    Kindly, visit your bank to instruct them accordingly.
                  </p>
                  <p class="font-13 text-dark text-center my-4">
                    Request that they send your 6 month bank statement to
                    <span class="text-orange">{{
                      this.loan.bank_statement_email
                    }}</span>
                  </p>
                  <p class="font-13 text-dark text-center my-4">
                    Your statement ID should be included in the email
                    <br />
                    <br />
                    <span
                      style="font-size: 22px;"
                      class="text-orange"
                      v-if="loan.processing_loan_information"
                      >{{
                        loan.processing_loan_information.statement_token
                      }}</span
                    >
                  </p>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <div
                    class="custom-control custom-checkbox font-weight-light mt-2 text-center"
                  >
                    <input
                      @click="confirmManualRetrieval"
                      type="checkbox"
                      class="custom-control-input"
                      id="confirm_copy"
                      name="confirm_copy"
                    />
                    <label
                      class="custom-control-label check_label font-13 text-dark text-center my-4"
                      for="confirm_copy"
                      >I have copied the token above</label
                    >
                  </div>

                  <button
                    type="button"
                    class="btn orange_button btn-block mt-1"
                    :disabled="!manual_retrieval_accepted"
                    @click="completeManualApplication"
                  >
                    Complete Application
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!--cancel loan modal -->
    <b-modal
      ref="cancel_modal"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <form>
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <div
                    class="custom-control custom-checkbox font-weight-light mt-3 text-center"
                  >
                    <p class="text-dark text-center small mb-0 mt-1">
                      By clicking the button below your processing loan will be
                      cancelled
                    </p>
                    <br />

                    <small class="text-orange"
                      >NOTE: Any payments made during this loan request will not
                      be refunded.</small
                    >
                  </div>
                  <br />
                  <br />

                  <button
                    type="button"
                    class="btn orange_button btn-block mt-1"
                    @click="cancelLoanApplication"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- trassaction success -->
    <b-modal
      ref="tranx_success_modal"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row justify-content-center">
              <div class="col-lg-10 text-center mb-4">
                <img src="@/assets/img/success.svg" />
                <p class=" text-orange text-center my-4">
                  Transaction Successful.
                </p>

                <small class="my-4"
                  >You can now proceed to confirming/retrieving your bank
                  statement
                </small>
              </div>

              <button @click="hidePaymentModal" class="btn btn-next px-5 next">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Manual remitta mandate activation modal -->
    <b-modal
      ref="manual_remitta_activation"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <h5 class="text-orange text-center">Manual Mandate Activation</h5>
          <div class="col-lg-12" style="min-height: 100px;">
            <p class="font-13 text-dark text-center my-4">
              If you choose to use the manual method of mandate activation,
              print the mandate activation form
              <span class="text-orange bank " @click="fetchMandateformURL">
                <strong><u>here.</u></strong>
              </span>

              <br />
              <br />

              <span class="text-orange">
                NOTE:
              </span>
              Allow popups so form will be opened in a new tab

              <br />
              <br />
              Take the form to the nearest branch of your salary acccount used
              in this application for activation.
            </p>
          </div>

          <div
            class="custom-control custom-checkbox font-weight-light mt-2 text-center"
          >
            <input
              @click="confirmManualActivation"
              type="checkbox"
              class="custom-control-input"
              id="confirm_copy"
              name="confirm_copy"
            />
            <label
              class="custom-control-label check_label font-13 text-dark text-center my-4"
              for="confirm_copy"
              >I have printed the mandate activation form
            </label>
          </div>

          <button
            type="button"
            class="btn orange_button btn-block mt-1"
            :disabled="!manual_activation_accepted"
            @click="completeManualMandateActivation"
          >
            Proceed
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Cheque repayment modal -->
    <b-modal
      ref="cheque_instruction"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <h5 class="text-orange text-center">Use Cheques</h5>
          <div class="col-lg-12" style="min-height: 70px;">
            <p class="font-13 text-dark text-center mt-2">
              Please note that if you choose to use cheques as your repayment
              instrument, you will have to present undated and unfilled cheque
              leaflets to orange one finance. Kindly contact your sales advisor
              or call us on <span class="text-orange">01-488889</span> or send
              an email to
              <span class="text-orange">enquiries@orangeonefinance.com</span>."
            </p>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- portal remitta mandate activation modal -->
    <b-modal
      ref="portal_remitta_activation"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="modal-body mb-4">
        <div class="row justify-content-center">
          <h5 class="text-orange text-center">
            Portal Mandate Activation
          </h5>
          <div class="col-lg-12" style="min-height: 100px;">
            <p class="font-13 text-dark text-center my-4">
              If you choose to use the portal method to activate your remitta
              madate, click on the button below so an OTP will be sent to your
              phone/Email. You can verify the OTP on the next screen.
            </p>
          </div>

          <button
            type="button"
            class="btn orange_button btn-block mt-1"
            @click="portalMandateActivation"
          >
            Proceed
          </button>
        </div>
      </div>
    </b-modal>

    <!-- offer modal -->
    <b-modal id="offer_modal" ref="offer_modal" hide-footer>
      <div class="modal-body mb-4" v-html="loan_offer"></div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import _ from "lodash";
import { Form } from "vform";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import LoanFacility from "../components/LoanFacility";
import { scroll, toggleFormLoading } from "@/Helpers/general";

import * as URL from "@/Endpoints/loan";

export default {
  name: "get-loan",
  layout: "app",
  middleware: "auth",
  computed: {
    ...mapGetters({
      user: "auth/user",
      loan: "loan/loan"
    }),
    statement_payment: function() {
      if (this.loan.processing_loan_information.bank_statement_info) {
        return JSON.parse(
          this.loan.processing_loan_information.bank_statement_info
        ).has_paid;
      }
      return false;
    },
    offer_url: function() {
      if (this.loan.offer) {
        return `${URL.DOWNLOAD_OFFER}/${this.loan.processing_loan_information.id}/${this.loan.offer.offer_token}`;
      }
      return "";
    }
  },
  components: {
    Datepicker,
    LoanFacility
  },
  watch: {
    "formfive.account_number": function() {
      if (this.begin_process) {
        this.debouncedGetAccName();
      }
    },
    "formone.state_of_origin": function(val) {
      if (this.begin_process) {
        toggleFormLoading(this);
        axios
          .get(`${URL.GET_STATE_LGA}/${val}`)
          .then(({ data }) => {
            this.loan_parameters.origin_lga = data.lga;
            toggleFormLoading(this);
          })
          .catch(() => {
            toggleFormLoading(this);
          });
      }
    },
    "formone.state_of_residence": function(val) {
      if (this.begin_process) {
        toggleFormLoading(this);
        axios
          .get(`${URL.GET_STATE_LGA}/${val}`)
          .then(({ data }) => {
            this.loan_parameters.residence_lga = data.lga;
            toggleFormLoading(this);
          })
          .catch(() => {
            toggleFormLoading(this);
          });
      }
    }
  },
  data: () => ({
    current_form: 1,
    begin_process: false,
    country_of_residence_search: false,
    nationality_search: false,
    document_uploading_progress: 0,
    offer_uploading_progress: 0,
    salary_date: "select salary date",
    manual_retrieval_accepted: false,
    manual_activation_accepted: false,
    loan_offer: null,
    offer_downloaded: true,
    loan_parameters: {
      origin_lga: [],
      residence_lga: [],
      states: [],
      employee_status: [],
      marital_status: [],
      countries: [],
      work_sector: [],
      year_range: [],
      banks: [],
      employee_loan_purpose: [],
      year: []
    },
    loan_results: {
      amount_interest: "",
      monthly_repayment: ""
    },
    loan_facility: [],
    last_facility_id: 1,
    formone: new Form({
      surname: "",
      firstname: "",
      middlename: "",
      email: "",
      mobile_number: "",
      dob: "",
      bvn: "",
      nationality: "NIGERIA",
      state_of_origin: "",
      LGA_of_origin: "",
      gender: "",
      marital_status: "",
      residential_address: "",
      country_of_residence: "NIGERIA",
      state_of_residence: "",
      LGA_of_residence: "",
      number_of_dependents: "",
      tax_ID: ""
    }),
    formtwo: new Form({
      company_name: "",
      occupation: "",
      work_address: "",
      work_sector: "",
      employee_status: "",
      years_in_employment: "",
      official_email: "",
      annual_income: "",
      monthly_net_salary: "",
      salary_date: "",
      emergency_firstname: "",
      emergency_surname: "",
      emergency_phone_number: "",
      emergency_email: "",
      emergency_relationship: "",
      emergency_address: "",
      existing_loan_facility: "",
      deduct_upfront_fee: 1
    }),
    formthree: new Form({
      passport_upload: "",
      ID_number: "",
      ID_expiry_date: "",
      ID_upload: "",
      utility_upload: "",
      employment_upload: ""
    }),
    formfour: new Form({
      loan_amount: "",
      loan_tenure: "",
      other_institutions_loan: 0,
      loan_purpose: ""
    }),
    formfive: new Form({
      bank_name: "",
      bank_code: "",
      bank_phone: "",
      account_number: "",
      account_name: ""
    }),
    formseven: new Form({
      ticket_number: "",
      password: ""
    }),
    remittaverification: new Form({
      rrr: "",
      otp: "",
      c_n: ""
    })
  }),
  methods: {
    onFileChange(e) {
      this.formthree.errors.clear(e.target.name);
      this.formthree[e.target.dataset.target] = e.target.files[0].name;
    },
    //  offerClicked() {}
    //  continue from last point
    async initializePreviousLoan() {
      toggleFormLoading(this);

      this.loanLoanParams();

      // FORM ONE

      if (this.loan.processing_loan_information.nationality) {
        this.formone.nationality = this.loan.processing_loan_information.nationality;
      }
      if (this.loan.processing_loan_information.state_of_origin) {
        this.formone.state_of_origin = parseInt(
          this.loan.processing_loan_information.state_of_origin
        );
      }
      if (this.loan.processing_loan_information.LGA_of_origin) {
        this.formone.LGA_of_origin = parseInt(
          this.loan.processing_loan_information.LGA_of_origin
        );
      }
      if (this.loan.processing_loan_information.gender) {
        this.formone.gender = this.loan.processing_loan_information.gender;
      }
      if (this.loan.processing_loan_information.marital_status) {
        this.formone.marital_status = parseInt(
          this.loan.processing_loan_information.marital_status
        );
      }
      if (this.loan.processing_loan_information.residential_address) {
        this.formone.residential_address = this.loan.processing_loan_information.residential_address;
      }

      if (this.loan.processing_loan_information.country_of_residence) {
        this.formone.country_of_residence = this.loan.processing_loan_information.country_of_residence;
      }
      if (this.loan.processing_loan_information.state_of_residence) {
        this.formone.state_of_residence = parseInt(
          this.loan.processing_loan_information.state_of_residence
        );
      }
      if (this.loan.processing_loan_information.LGA_of_residence) {
        this.formone.LGA_of_residence = parseInt(
          this.loan.processing_loan_information.LGA_of_residence
        );
      }

      if (this.loan.processing_loan_information.number_of_dependents) {
        this.formone.number_of_dependents = this.loan.processing_loan_information.number_of_dependents;
      }
      if (this.loan.processing_loan_information.tax_ID) {
        this.formone.tax_ID = this.loan.processing_loan_information.tax_ID;
      }

      // FORM TWO
      if (this.loan.processing_loan_information.company_name) {
        this.formtwo.company_name = this.loan.processing_loan_information.company_name;
      }
      if (this.loan.processing_loan_information.occupation) {
        this.formtwo.occupation = this.loan.processing_loan_information.occupation;
      }
      if (this.loan.processing_loan_information.work_address) {
        this.formtwo.work_address = this.loan.processing_loan_information.work_address;
      }

      if (this.loan.processing_loan_information.work_sector) {
        this.formtwo.work_sector = parseInt(
          this.loan.processing_loan_information.work_sector
        );
      }
      if (this.loan.processing_loan_information.employee_status) {
        this.formtwo.employee_status = parseInt(
          this.loan.processing_loan_information.employee_status
        );
      }
      if (this.loan.processing_loan_information.employee_status) {
        this.formtwo.employee_status = parseInt(
          this.loan.processing_loan_information.employee_status
        );
      }

      if (this.loan.processing_loan_information.years_in_employment) {
        this.formtwo.years_in_employment = this.loan.processing_loan_information.years_in_employment;
      }
      if (this.loan.processing_loan_information.official_email) {
        this.formtwo.official_email = this.loan.processing_loan_information.official_email;
      }
      if (this.loan.processing_loan_information.annual_income) {
        this.formtwo.annual_income = this.loan.processing_loan_information.annual_income;
      }
      if (this.loan.processing_loan_information.monthly_net_salary) {
        this.formtwo.monthly_net_salary = this.loan.processing_loan_information.monthly_net_salary;
      }
      if (this.loan.processing_loan_information.salary_date) {
        this.formtwo.salary_date = this.loan.processing_loan_information.salary_date;
      }
      if (this.loan.processing_loan_information.emergency_firstname) {
        this.formtwo.emergency_firstname = this.loan.processing_loan_information.emergency_firstname;
      }
      if (this.loan.processing_loan_information.emergency_surname) {
        this.formtwo.emergency_surname = this.loan.processing_loan_information.emergency_surname;
      }
      if (this.loan.processing_loan_information.emergency_phone_number) {
        this.formtwo.emergency_phone_number = this.loan.processing_loan_information.emergency_phone_number;
      }
      if (this.loan.processing_loan_information.emergency_email) {
        this.formtwo.emergency_email = this.loan.processing_loan_information.emergency_email;
      }
      if (this.loan.processing_loan_information.emergency_relationship) {
        this.formtwo.emergency_relationship = this.loan.processing_loan_information.emergency_relationship;
      }
      if (this.loan.processing_loan_information.emergency_address) {
        this.formtwo.emergency_address = this.loan.processing_loan_information.emergency_address;
      }
      if (this.loan.processing_loan_information.existing_loan_facility) {
        let parsed = JSON.parse(
          this.loan.processing_loan_information.existing_loan_facility
        );

        [...parsed].forEach(facility => {
          this.loan_facility.push(facility);
        });
      }

      if (this.loan.processing_loan_information.deduct_upfront_fee == "1") {
        this.formtwo.deduct_upfront_fee = this.loan.processing_loan_information.deduct_upfront_fee;
      }

      // FORM THREE
      if (this.loan.processing_loan_information.passport_upload) {
        this.formthree.passport_upload = this.loan.processing_loan_information.passport_upload;
      }
      if (this.loan.processing_loan_information.ID_number) {
        this.formthree.ID_number = this.loan.processing_loan_information.ID_number;
      }
      if (this.loan.processing_loan_information.ID_expiry_date) {
        this.formthree.ID_expiry_date = this.loan.processing_loan_information.ID_expiry_date;
      }

      if (this.loan.processing_loan_information.ID_upload) {
        this.formthree.ID_upload = this.loan.processing_loan_information.ID_upload;
      }
      if (this.loan.processing_loan_information.utility_upload) {
        this.formthree.utility_upload = this.loan.processing_loan_information.utility_upload;
      }
      if (this.loan.processing_loan_information.employment_upload) {
        this.formthree.employment_upload = this.loan.processing_loan_information.employment_upload;
      }

      // FORM FOUR

      if (this.loan.processing_loan_information.loan_amount) {
        this.formfour.loan_amount = parseInt(
          this.loan.processing_loan_information.loan_amount
        );
      }

      if (this.loan.processing_loan_information.loan_tenure) {
        this.formfour.loan_tenure = this.loan.processing_loan_information.loan_tenure;
      }

      if (this.loan.processing_loan_information.other_institutions_loan) {
        this.formfour.other_institutions_loan = parseInt(
          this.loan.processing_loan_information.other_institutions_loan
        );
      }

      if (this.loan.processing_loan_information.loan_purpose) {
        this.formfour.loan_purpose = parseInt(
          this.loan.processing_loan_information.loan_purpose
        );
      }

      // FORM FIVE

      if (this.loan.processing_loan_information.bank_name) {
        this.formfive.bank_name = this.loan.processing_loan_information.bank_name;
      }

      if (this.loan.processing_loan_information.bank_code) {
        this.formfive.bank_code = this.loan.processing_loan_information.bank_code;
      }

      if (this.loan.processing_loan_information.account_number) {
        this.formfive.account_number = this.loan.processing_loan_information.account_number;
      }

      if (this.loan.processing_loan_information.account_name) {
        this.formfive.account_name = this.loan.processing_loan_information.account_name;
      }
      if (this.loan.processing_loan_information.bank_phone) {
        this.formfive.bank_phone = this.loan.processing_loan_information.bank_phone;
      }

      // OTHERr
      if (this.loan.processing_loan_information.amount_interest) {
        this.loan_results.amount_interest = this.loan.processing_loan_information.amount_interest;
      }

      if (this.loan.processing_loan_information.monthly_repayment) {
        this.loan_results.monthly_repayment = this.loan.processing_loan_information.monthly_repayment;
      }
      // if (this.loan.processing_loan_information.monthly_repayment) {
      //   this.loan_results.amount_payable = this.loan.processing_loan_information.amount_payable;
      // }

      // DEPENDENT PARAMETERS
      const axiosParams = new URLSearchParams();
      axiosParams.append(
        "state_of_origin",
        this.loan.processing_loan_information.state_of_origin
      );
      axiosParams.append(
        "state_of_residence",
        this.loan.processing_loan_information.state_of_residence
      );

      try {
        const { data } = await axios.get(URL.GET_PREVIOUS_LGA_PARAMS, {
          params: axiosParams
        });
        toggleFormLoading(this);

        this.$notify({
          group: "foo",
          duration: 7000,
          title: "SUCCESS",
          type: "success",
          text: "Continue application..."
        });

        // APPEND DEPENDENT PARAMETERS

        this.loan_parameters.origin_lga = data.origin_lga;
        this.loan_parameters.residence_lga = data.residence_lga;

        // lOAD NEXT FILLABLE FORM
        this.current_form =
          parseInt(this.loan.processing_loan_information.last_form) + 1;

        // TURN THE LIGHTS ON
        this.begin_process = true;
      } catch (error) {
        toggleFormLoading(this);
      }
    },
    async submitFirstForm() {
      toggleFormLoading(this);
      let form_one_url;

      if (this.loan.has_processing) {
        // Url to update
        form_one_url = this.updateURL(URL.UPDATE_LOAN_FORM_ONE);
      } else {
        // url for new
        form_one_url = URL.SUBMIT_LOAN_FORM_ONE;
      }

      try {
        // eslint-disable-next-line no-unused-vars
        const { data } = await this.formone.post(form_one_url);

        this.PostUpdateAction(data);
      } catch (error) {
        toggleFormLoading(this);
        scroll();
      }
    },
    async submitSecondForm() {
      toggleFormLoading(this);

      try {
        // gather loan facilities
        const facilities = document.querySelectorAll(".facility");
        const facilityOBJ = [];
        if (facilities.length > 0) {
          [...facilities].forEach((facility, index) => {
            let amount = facility.querySelector(".amount").value;
            let institution = facility.querySelector(".institution").value;
            if (amount !== "" && institution !== "") {
              facilityOBJ.push({ amount, institution, id: index++ });
            }
          });
          this.formtwo.existing_loan_facility = JSON.stringify(facilityOBJ);
        }

        const { data } = await this.formtwo.post(
          this.updateURL(URL.UPDATE_LOAN_FORM_TWO)
        );

        this.PostUpdateAction(data);
      } catch (error) {
        toggleFormLoading(this);
        scroll();
      }
    },
    submitThirdForm() {
      toggleFormLoading(this);
      this.document_uploading_progress = 0;
      this.uploadDocuments();
    },
    async submitFourthForm() {
      toggleFormLoading(this);

      try {
        const { data } = await this.formfour.post(
          this.updateURL(URL.UPDATE_LOAN_FORM_FOUR)
        );
        this.PostUpdateAction(data);

        this.loan_results.amount_interest = data.data.amount_interest;

        this.loan_results.monthly_repayment = data.data.monthly_repayment;
        //   this.loan_results.amount_payable = data.data.amount_payable;
      } catch (error) {
        toggleFormLoading(this);
        scroll();
      }
    },
    async submitFifthForm() {
      toggleFormLoading(this);

      try {
        const { data } = await this.formfive.post(
          this.updateURL(URL.UPDATE_LOAN_FORM_FIVE)
        );
        this.PostUpdateAction(data);
      } catch (error) {
        toggleFormLoading(this);
        scroll();
      }
    },
    async submitSeventhForm() {
      toggleFormLoading(this);

      try {
        const { data } = await this.formseven.post(
          this.updateURL(URL.CONFIRM_BANK_STATEMENT)
        );
        toggleFormLoading(this);

        if (data.status) {
          this.$store.dispatch("loan/updateProcessing", {
            loan: data
          });

          this.current_form = 8;

          this.$notify({
            group: "foo",
            title: "SUCCESS",
            duration: 7000,
            type: "success",
            text: "Bank statement retrieved successfully!"
          });
        } else {
          this.$notify({
            group: "foo",
            title: "INFO:",
            duration: 7000,
            type: "error",
            text: data.message
          });
        }
      } catch (error) {
        toggleFormLoading(this);
      }
    },
    async uploadDocuments() {
      let self = this;
      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          self.document_uploading_progress = percentCompleted;
        }
      };
      let postdata = new FormData();

      if (this.$refs.passport_upload.files[0]) {
        postdata.append("passport_upload", this.$refs.passport_upload.files[0]);
      }

      if (this.$refs.ID_upload.files[0]) {
        postdata.append("ID_upload", this.$refs.ID_upload.files[0]);
      }

      if (this.$refs.utility_upload.files[0]) {
        postdata.append("utility_upload", this.$refs.utility_upload.files[0]);
      }

      if (this.$refs.employment_upload.files[0]) {
        postdata.append(
          "employment_upload",
          this.$refs.employment_upload.files[0]
        );
      }

      try {
        const { data } = await axios.post(
          this.updateURL(URL.FORM_THREE_UPLOADS),
          postdata,
          config
        );

        let res = data.data;

        for (var item in res) {
          // eslint-disable-next-line no-prototype-builtins
          if (res.hasOwnProperty(item)) {
            self.formthree[item] = res[item];
          }
        }

        this.$store.dispatch("loan/updateDocumentUpload");

        this.submitUploadedDocuments();
      } catch (error) {
        toggleFormLoading(this);
        scroll();

        this.$notify({
          group: "foo",
          title: "INFO:",
          duration: 7000,
          type: "error",
          text: "An error has occured!"
        });
      }
    },
    async submitUploadedDocuments() {
      // toggleFormLoading(this);
      try {
        const { data } = await this.formthree.post(
          this.updateURL(URL.UPDATE_LOAN_FORM_THREE)
        );

        this.PostUpdateAction(data);
      } catch (error) {
        toggleFormLoading(this);
        scroll();
      }
    },
    // sets unchangabe user data
    setDefaultvalues() {
      this.formone.surname = this.user.surname;
      this.formone.firstname = this.user.firstname;
      this.formone.middlename = this.user.middlename;
      this.formone.email = this.user.email;
      this.formone.mobile_number = this.user.phone;
      this.formone.dob = this.user.date_of_birth;
      this.formone.bvn = this.user.bvn;
    },
    PostUpdateAction(data) {
      toggleFormLoading(this);
      if (data.status) {
        this.$store.dispatch("loan/updateProcessing", {
          loan: data
        });
        this.$notify({
          group: "foo",
          title: "SUCCESS",
          duration: 7000,
          type: "success",
          text: "Progress saved!"
        });
        scroll();
        this.next();
      } else {
        this.$notify({
          group: "foo",
          title: "INFO:",
          duration: 7000,
          type: "error",
          text: data.message
        });
      }
    },
    //loads items needed for loan request process
    async loanLoanParams() {
      try {
        const { data } = await axios.get(URL.GET_LOAN_PARAMETERS);

        this.loan_parameters.states = data.states;
        this.loan_parameters.marital_status = data.marital_status;
        this.loan_parameters.work_sector = data.work_sector;
        this.loan_parameters.employee_status = data.employee_status;
        this.loan_parameters.employee_loan_tenure = data.employee_loan_tenure;
        this.loan_parameters.employee_loan_purpose = data.employee_loan_purpose;
        this.loan_parameters.banks = data.banks;

        let currentYear = moment().format("YYYY");

        let start = +currentYear - 10;
        let end = +currentYear + 35;

        for (let i = start; i < end; i++) {
          this.loan_parameters.year.push({ id: i, title: i });
        }
      } catch (error) {
        this.$notify({
          group: "foo",
          title: "INFO:",
          duration: 7000,
          type: "error",
          text: "Unable to perform action!!"
        });
      }
    },
    clearError(e) {
      this.formone.errors.clear(e.target.name);
      this.formtwo.errors.clear(e.target.name);
      this.formfive.errors.clear(e.target.name);
    },
    next() {
      this.current_form++;
    },
    back() {
      this.current_form--;
    },
    triggerCancelModal() {
      this.$refs["cancel_modal"].show();
    },
    cancelLoanApplication() {
      toggleFormLoading(this);
      const self = this;

      axios
        .post(this.updateURL(URL.CANCEL_lOAN_APPLICATION), {})
        .then(({ data }) => {
          toggleFormLoading(self);
          if (data.status) {
            this.$store.dispatch("loan/clearProcessing", {
              id: this.loan.processing_loan_information.id
            });

            self.$router.push("dashboard");
            self.$notify({
              group: "foo",
              title: "SUCCESS",
              duration: 7000,
              type: "success",
              text: "Loan Application Cancelled."
            });
          } else {
            this.$notify({
              group: "foo",
              title: "INFO:",
              duration: 7000,
              type: "error",
              text: data.message
            });
          }
        });
    },
    addExistingLoanFacility() {
      this.loan_facility.push({
        id: this.last_facility_id,
        amount: "",
        institution: ""
      });

      this.last_facility_id++;
    },
    removeExistingLoanFacility(index) {
      this.loan_facility.splice(index, 1);
    },
    customDateFormat(date) {
      return moment(date).format("Do");
    },
    customExpiryDateFormat(date) {
      return moment(date).format("MMMM YYYY");
    },
    updateURL(endpoint) {
      return endpoint + "/" + this.loan.processing_loan_information.id;
    },
    bankNameChanged(e) {
      this.formfive.errors.clear(e.target.name);
      this.formfive.account_name = "";
      this.formfive.account_number = "";
      // this.formfive.bank_phone = "";
    },
    getAccName() {
      if (this.formfive.account_number.length == 10) {
        toggleFormLoading(this);
        axios
          .post(URL.RESOLVE_ACCOUNT_NUMBER, {
            id: this.formfive.bank_name,
            account_number: this.formfive.account_number
          })
          .then(({ data }) => {
            toggleFormLoading(this);
            if (data.status) {
              this.formfive.account_name = data.data.account_name;
              this.formfive.bank_code = data.bank_code;
              this.formfive.errors.clear("account_name");
            } else {
              this.$notify({
                group: "foo",
                title: "INFO:",
                duration: 7000,
                type: "error",
                text: "Unable to fetch bank name. Please try again."
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            toggleFormLoading(this);
            this.$notify({
              group: "foo",
              title: "INFO:",
              duration: 7000,
              type: "error",
              text: "An error occured while fetching bank name!"
            });
          });
      }
    },
    triggerCustomRetrievalModal() {
      this.$refs["custom_retrieval_init"].show();
    },
    toPaymentpage() {
      this.current_form = 7;
      this.$refs["custom_retrieval_init"].hide();
    },
    triggerManualRetrievalModal() {
      this.$refs["manual_retrieval"].show();
    },
    chequeInstruction() {
      this.$refs["cheque_instruction"].show();
    },
    triggerAutoRetrievalModal() {
      this.$refs["automatic_retrieval_init"].show();
    },
    confirmManualRetrieval() {
      this.manual_retrieval_accepted = !this.manual_retrieval_accepted;
    },
    confirmManualActivation() {
      this.manual_activation_accepted = !this.manual_activation_accepted;
    },
    completeManualApplication() {
      toggleFormLoading(this);
      axios
        .post(this.updateURL(URL.COMPLETE_MANUAL_lOAN_APPLICATION), {
          statement_retrieval_mode: "manual"
        })
        .then(({ data }) => {
          toggleFormLoading(this);
          if (data.status) {
            this.$refs["manual_retrieval"].hide();
            this.current_form = 9;
            this.$store.dispatch("loan/updateProcessing", {
              loan: data
            });
            this.$notify({
              group: "foo",
              title: "SUCCESS",
              duration: 7000,
              type: "success",
              text: "Application completed"
            });
          } else {
            this.$notify({
              group: "foo",
              title: "INFO:",
              duration: 7000,
              type: "error",
              text: data.message
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          toggleFormLoading(this);
          this.$notify({
            group: "foo",
            title: "INFO:",
            duration: 7000,
            type: "error",
            text: "An error has occured"
          });
        });
    },
    differentStatementProcess(e) {
      e.preventDefault();
      this.$refs["automatic_retrieval_init"].hide();
      this.$refs["different_statement_process"].show();
    },
    initAutomaticStatementRetrieval() {
      toggleFormLoading(this);
      let self = this;

      axios
        .post(this.updateURL(URL.INITIALIZE_BANK_STATEMENT), {})
        .then(({ data }) => {
          toggleFormLoading(this);

          if (data.status) {
            this.$refs["automatic_retrieval_init"].hide();

            this.$store.dispatch("loan/updateProcessing", {
              loan: data
            });
            self.$notify({
              group: "foo",
              title: "SUCCESS",
              duration: 7000,
              type: "success",
              text: "Progress saved!"
            });

            self.current_form = 7;
          } else {
            this.notifyError(data.message);
          }
        })
        .catch(error => {
          toggleFormLoading(this);
          this.notifyError(error.message);
        });
    },
    hidePaymentModal() {
      // this.$router.push("/get-loan");
      this.$router.push({ name: "get-loan" });
      this.$refs["tranx_success_modal"].hide();
    },
    payStatementFee() {
      toggleFormLoading(this);
      let self = this;

      axios
        .post(this.updateURL(URL.STATEMENT_PAYMENT), {})
        .then(({ data }) => {
          toggleFormLoading(this);

          if (data.status) {
            window.location.href = data.data.authorization_url;
          } else {
            self.$notify({
              group: "foo",
              duration: 7000,
              title: "INFO:",
              type: "error",
              text: data.message
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          toggleFormLoading(this);
          this.notifyError("An error occured while initilizing payment!");
        });
    },
    verifyTransaction() {
      axios
        .post(URL.VERIFY_STATEMENT_PAYMENT, {
          reference: this.$route.query.reference,
          loan_id: this.loan.processing_loan_information.id
        })
        .then(({ data }) => {
          toggleFormLoading(this);

          if (data.status) {
            this.$refs["tranx_success_modal"].show();
            this.current_form = 7;
            this.begin_process = true;
            this.$store.dispatch("loan/updateProcessing", {
              loan: data
            });
          } else {
            this.$notify({
              group: "foo",
              duration: 7000,
              title: "INFO:",
              type: "error",
              text: data.message
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          toggleFormLoading(this);
          this.notifyError("An error occured while verifying transaction!");
        });
    },
    notifyError(message) {
      this.$notify({
        group: "foo",
        duration: 7000,
        title: "INFO:",
        type: "error",
        text: message
      });
    },
    getStatusId(needle, haystack) {
      return haystack.filter(index => index.slug == needle)[0].id;
    },

    async uploadOffer() {
      let self = this;
      const config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          self.offer_uploading_progress = percentCompleted;
        }
      };
      let postdata = new FormData();

      if (this.$refs.reuploadOffer.files[0]) {
        postdata.append("offer", this.$refs.reuploadOffer.files[0]);

        try {
          const { data } = await axios.post(
            this.updateURL(URL.UPLOAD_OFFER),
            postdata,
            config
          );

          if (data.status) {
            this.$store.dispatch("loan/updateProcessing", {
              loan: data
            });

            if (data.reload) {
              window.location.reload(true);
            } else {
              this.current_form = 11;
            }

            this.$notify({
              group: "foo",
              title: "SUCCESS",
              duration: 7000,
              type: "success",
              text: "Offer letter saved!"
            });
          } else {
            this.$notify({
              group: "foo",
              title: "INFO:",
              duration: 7000,
              type: "error",
              text: "Offer letter not saved!"
            });
          }
        } catch (error) {
          scroll();

          this.$notify({
            group: "foo",
            title: "INFO:",
            duration: 7000,
            type: "error",
            text: "An error has occured! please try again"
          });
        }
      } else {
        this.$notify({
          group: "foo",
          title: "INFO:",
          duration: 7000,
          type: "error",
          text: "You forgot the offer letter"
        });
      }
    },

    // Remitta
    setupMandate() {
      toggleFormLoading(this);

      axios
        .post(this.updateURL(URL.SETUP_MANDATE), {})
        .then(({ data }) => {
          toggleFormLoading(this);

          if (data.status) {
            this.$store.dispatch("loan/updateProcessing", {
              loan: data
            });

            this.current_form = 15;

            this.$notify({
              group: "foo",
              title: "SUCCESS",
              duration: 7000,
              type: "success",
              text: "Mandate setup successfully"
            });
          } else {
            this.notifyError(data.message);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          toggleFormLoading(this);
          this.notifyError("Please try setting up madate again");
        });
    },
    fetchMandateformURL() {
      toggleFormLoading(this);

      axios
        .post(this.updateURL(URL.MANDATE_FORM), {})
        .then(({ data }) => {
          toggleFormLoading(this);

          if (data.status) {
            window.open(data.data, "_blank");
          } else {
            this.notifyError(data.message);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          toggleFormLoading(this);
          this.notifyError("Please try setting up madate again");
        });
    },

    completeManualMandateActivation() {
      toggleFormLoading(this);
      var self = this;

      axios
        .post(this.updateURL(URL.MANUAL_MADATE_ACTIVATION), {})
        .then(({ data }) => {
          toggleFormLoading(this);

          if (data.status) {
            self.$refs["manual_remitta_activation"].hide();

            this.$store.dispatch("loan/updateProcessing", {
              loan: data
            });

            this.current_form = 16;

            this.$notify({
              group: "foo",
              title: "SUCCESS",
              duration: 7000,
              type: "success",
              text: "Mandate activation method set"
            });
          } else {
            this.notifyError(data.message);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          toggleFormLoading(this);
          this.notifyError("Please try setting up madate again");
        });
    },
    triggerManualRemittaModal() {
      this.$refs["manual_remitta_activation"].show();
    },
    triggerAutoRemittaModal() {
      this.$refs["portal_remitta_activation"].show();
    },

    portalMandateActivation() {
      toggleFormLoading(this);

      axios
        .post(this.updateURL(URL.REMITTA_PORTAL_ACTIVATION), {})
        .then(({ data }) => {
          toggleFormLoading(this);

          console.log(data);

          if (data.status) {
            this.$refs["portal_remitta_activation"].hide();
            this.$store.dispatch("loan/updateProcessing", {
              loan: data
            });

            this.remittaverification.rrr = data.data.remitta_transfer_reference;

            this.current_form = 12;

            this.$notify({
              group: "foo",
              title: "SUCCESS",
              duration: 7000,
              type: "success",
              text: "Successful"
            });
          } else {
            this.notifyError(data.message);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          console.log(error.message);

          toggleFormLoading(this);
          this.notifyError(
            "Unable to use the portal method at this time, pls try again or use the manual method."
          );
        });
    },
    async verifyRemittaMandate() {
      toggleFormLoading(this);

      try {
        let self = this;

        // eslint-disable-next-line no-unused-vars
        const { data } = await this.remittaverification.post(
          this.updateURL(URL.ACTIVATE_MANDATE)
        );

        toggleFormLoading(self);
        scroll();
        if (data.status) {
          this.$store.dispatch("loan/completeLoan");

          self.current_form = 13;

          self.$notify({
            group: "foo",
            title: "SUCCESS",
            duration: 7000,
            type: "success",
            text: "Loan Application Completed."
          });
        } else {
          this.$notify({
            group: "foo",
            duration: 7000,
            title: "INFO:",
            type: "error",
            text: data.message
          });
        }
      } catch (error) {
        toggleFormLoading(this);
        scroll();
      }
    },
    fetchCountry(value, loader) {
      axios
        .post(URL.COUNTRY, {
          name: value
        })
        .then(({ data }) => {
          this.$refs[loader].style.display = "none";
          this.loan_parameters.countries = data.countries;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          this.notifyError("Unable to fetch country");
        });
    },
    initializeNationality(e) {
      let value = e.target.value;
      if (value.trim().length >= 1) {
        this.nationality_search = true;
        this.$refs[e.target.dataset.loader].style.display = "block";
        this.fetchCountry(value, e.target.dataset.loader);
      } else {
        this.nationality_search = false;
      }
    },
    selectNationlity(e) {
      this.formone.nationality = e.target.dataset.name;
      this.loan_parameters.countries = [];
      this.nationality_search = false;
    },
    initializeCountryOfResidence(e) {
      let value = e.target.value;
      if (value.trim().length >= 1) {
        this.country_of_residence_search = true;
        this.$refs[e.target.dataset.loader].style.display = "block";
        this.fetchCountry(value, e.target.dataset.loader);
      } else {
        this.country_of_residence_search = false;
      }
    },
    selectResidenceCountry(e) {
      this.formone.country_of_residence = e.target.dataset.name;
      this.loan_parameters.countries = [];
      this.country_of_residence_search = false;
    },
    //  Make decision on the form view to display
    displayController() {
      if (this.loan.can_request_loan) {
        // does the user have a processing loan?
        if (this.loan.has_processing) {
          //   has the form been submitted?
          if (this.loan.processing_loan_information.is_submitted == 1) {
            // what is the statement retrieval method?

            let stmt_opts = JSON.parse(
              this.loan.processing_loan_information.bank_statement_info
            );

            switch (stmt_opts.method) {
              case "automatic":
                // is completed?

                if (stmt_opts.status === "completed") {
                  this.current_form = 8;
                  this.begin_process = true;
                } else {
                  // Not completed
                  this.current_form = 7;
                  this.begin_process = true;
                }

                break;
              case "manual":
                this.current_form = 9;
                this.begin_process = true;

                break;
            }
          } else {
            // No form has not been submitted
            this.initializePreviousLoan();
            this.addExistingLoanFacility();
          }
        } else {
          //  No processing loan so start new application
          this.loanLoanParams();
          this.begin_process = true;
          this.addExistingLoanFacility();
        }
      } else {
        // is there an approved loan ?

        if (this.loan.has_approved) {
          // has offer been accepted

          if (this.loan.processing_loan_information.offer_accepted) {
            // proceed to mandate

            // has the madate been initiated

            let mandate_status = parseInt(
              this.loan.processing_loan_information.mandate_status
            );

            if (mandate_status) {
              if (this.loan.processing_loan_information.mandate_method) {
                if (
                  this.loan.processing_loan_information.mandate_method ===
                  "manual"
                ) {
                  switch (mandate_status) {
                    case this.getStatusId(
                      "mandate_initialized",
                      this.loan.mandate_status
                    ):
                      this.current_form = 16;
                      this.begin_process = true;

                      break;
                    case this.getStatusId(
                      "mandate_verified",
                      this.loan.mandate_status
                    ):
                      this.current_form = 13;
                      this.begin_process = true;

                      break;

                    default:
                      break;
                  }
                } else if (
                  this.loan.processing_loan_information.mandate_method ===
                  "portal"
                ) {
                  this.remittaverification.rrr = this.loan.processing_loan_information.remitta_transfer_reference;

                  switch (mandate_status) {
                    case this.getStatusId(
                      "mandate_initialized",
                      this.loan.mandate_status
                    ):
                      this.current_form = 12;
                      this.begin_process = true;

                      break;
                    case this.getStatusId(
                      "mandate_verified",
                      this.loan.mandate_status
                    ):
                      this.current_form = 13;
                      this.begin_process = true;

                      break;

                    default:
                      break;
                  }
                }
              } else {
                this.current_form = 15;
                this.begin_process = true;
              }
            } else {
              this.current_form = 11;
              this.begin_process = true;
            }
          } else {
            this.current_form = 14;
            this.begin_process = true;
          }
        } else {
          // No cannot request new loan
          this.current_form = 10;
          this.begin_process = true;
        }
      }

      this.setDefaultvalues();
    }
  },
  mounted() {},
  created() {
    if (this.$route.query.reference) {
      toggleFormLoading(this);

      this.verifyTransaction();
    } else {
      this.displayController();

      // this.current_form = 5;
      // this.begin_process = true;

      this.debouncedGetAccName = _.debounce(this.getAccName, 1000);
      this.debounceNationality = _.debounce(this.initializeNationality, 500);
      this.debounceCountryOfResidence = _.debounce(
        this.initializeCountryOfResidence,
        500
      );
    }
  }
};
</script>

<style>
.modal-header {
  border-bottom: none;
}

.text-blue-underline {
  color: #007bff;
  text-decoration: underline;
}

.disabled {
  cursor: not-allowed;
}

.countries_list {
  border: 1px solid gainsboro;
  background-color: #fff;
  min-height: 50px;
  width: 95%;
  position: absolute;
  top: 90px;
  z-index: 100;
  transition: all 1s ease-in;
}

.countries_list ul {
  margin: 0;
  padding: 0;
  padding-top: 10px 20px;
  list-style: none;
}

.countries_list li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 80%;
  color: #888;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}

.countries_list li:hover {
  background-color: #eee;
}

.country-loader {
  display: none;
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #fd6c1d;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 16px;
  top: 48px;
  -webkit-animation: spin 0.5s linear infinite;
  /* Safari */
  animation: spin 0.5s linear infinite;
}

.pay {
  padding: 8px 40px;
  border-radius: 2px;
}

.no_action {
  opacity: 0.5;
  cursor: no-drop;
}

.bank {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.bank:hover {
  transform: scale(1.1);
}

#offer_modal .modal-dialog {
  width: 80% !important;
  max-width: 80% !important;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
